export default "/assets/images/CC-stats-graph-lg.2d5bbdbd19c668f0.png";